import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import packageJson from "../../../package.json";

import type { JSX } from "react";

interface AppVersionProps {
  isCollapsed?: boolean;
  collapsedSidebarClassNames: (isCollapsed?: boolean) => string;
}

export default function AppVersion({
  isCollapsed,
  collapsedSidebarClassNames,
}: AppVersionProps): JSX.Element {
  const { t } = useTranslation("editor-menu");

  const versionTextClassNames = classNames(
    collapsedSidebarClassNames(isCollapsed),
  );

  return (
    <div className="text-muted-foreground mb-[0.3125rem] text-center text-[0.703125rem] whitespace-nowrap">
      <span className={versionTextClassNames}>
        {isCollapsed ? "" : `${t("version")} `}
      </span>
      {packageJson.version}
    </div>
  );
}
